// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attachment-container svg{filter:drop-shadow(0 0 30px rgb(0,0,0))}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/modals/AssetModal.vue"],"names":[],"mappings":"AAEE,0BACE,uCADJ","sourcesContent":["\n.attachment-container {\n  svg {\n    filter: drop-shadow(0px 0px 30px rgba(0, 0, 0, 1));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
